<script>
import Page from '@/components/elements/Page';
import PageIntro from '@/components/elements/PageIntro';
import ResendVerificationCode from '@/components/views/CW/_shared/IresendVerificationCode.vue';
export default {
    name: 'signupVerification',
    components: { Page, PageIntro, ResendVerificationCode },
    data() {
        return {
            verificationCode: '',
            email: '',
            idnumber: null,
            contactmethodnr: '1',
            phonenumber: '',
            contacttypestring: ''
        }
    },
    methods: {
        isNumber: function(evt) {
            // evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        back() {
            this.$router.push({ name: 'signupInformation' })
        },
        ValidateCode() {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.$store.state.accToken}`
            }
            this.$axios
                .put(this.$config.apiacthealth + 'signup', { idnumber: this.idnumber, code: this.verificationCode, email: this.email },
                    { headers })
                .then(response => {
                    if (response.data === 1) {
                        this.$store.state.aanMeldingVerify = true;
                        this.$store.state.aanMelding2FA = true;
                        this.$store.state.signupIDTYPE = null;
                        this.$store.state.signupEmail = '';
                        this.$store.state.signupIdnumber = '';
                        this.$store.state.signupDEFAULTCOUNTRYCODE = null;
                        this.$store.state.signupPHONENUMBER = '';
                        this.$store.state.signupDAILCODE = '';
                        this.$store.state.signupCONTACTMETHODNR = 1;
                        this.$store.state.signupBATCHNR = '';
                        this.$store.state.signupLOCATIONFIRSTVAC = '';
                        this.$store.state.signupDATEFIRSTVAC = '';
                        this.$store.state.signupDATEFIRSTVACDD = '';
                        this.$store.state.signupDATEFIRSTVACMM = '';
                        this.$store.state.signupDATEFIRSTVACYYYY = '';
                        this.$router.push({ name: 'signupSuccess' });
                    } else {
                        this.$store.state.aanMeldingVerify = false;
                        this.$store.commit('modal/set', {
                            messageHead: this.$t('message.error.invalidVerificationCode.head'),
                            messageBody: this.$t('message.error.invalidVerificationCode.body', { code: this.$t('notfound') }),
                            closeButton: true
                        });
                    }
                })
                .catch(error => {
                    if (error.response) {
                        const status = error.response.status;
                        switch (status) {
                        case 401:
                            alert('Error 403');
                            break;
                        case 403:
                            alert('Error 403');
                            break;
                        case 500:
                            alert('Error 403');
                            break;
                        default:
                            this.$store.commit('modal/set', {
                                messageHead: this.$t('message.error.general.head'),
                                messageBody: this.$t('message.error.general.body'),
                                closeButton: true
                            });
                        }
                    }
                })
        },
        resendVerificationCode() {
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.$store.state.accToken}`
            }
            this.$axios
                .put(this.$config.apiacthealth + 'signup/resendVerificationCode', { idnumber: this.idnumber, email: this.email, LANGUAGENR: this.$store.state.languages.current.id },
                    { headers })
                .then(response => {
                    if (response.data === 1) {
                        this.$store.commit('modal/set', {
                            messageHead: this.$t('message.info.resendverificationCode.head'),
                            messageBody: this.$t('message.info.resendverificationCode.body', { contacttype: this.$t(this.contacttypestring) }),
                            closeButton: true
                        });
                    } else {
                        this.$store.commit('modal/set', {
                            messageHead: this.$t('message.error.general.head'),
                            messageBody: this.$t('message.error.general.body'),
                            closeButton: true
                        });
                    }
                })
                .catch(error => {
                    if (error.response) {
                        const status = error.response.status;
                        switch (status) {
                        case 401:
                            alert('Error 403');
                            break;
                        case 403:
                            alert('Error 403');
                            break;
                        case 500:
                            alert('Error 403');
                            break;
                        default:
                            this.$store.commit('modal/set', {
                                messageHead: this.$t('message.error.general.head'),
                                messageBody: this.$t('message.error.general.body'),
                                closeButton: true
                            });
                        }
                    }
                })
        }
    },
    mounted() {
        if ((this.$store.state.signupEmail !== '') && (this.$store.state.signupIdnumber !== '') && (this.$store.state.userConsent === true)) {
            this.email = this.$store.state.signupEmail;
            this.idnumber = this.$store.state.signupIdnumber;
            this.contactmethodnr = this.$store.state.signupCONTACTMETHODNR;
            this.phonenumber = this.$store.state.signupPHONENUMBER;
            if (Number(this.contactmethodnr) === 1) {
                this.contacttypestring = 'emailadres';
            } else {
                this.contacttypestring = 'phonenumber';
            }
        } else {
            this.$router.push({ name: 'Home' });
        }
    }
}
</script>

<template>
 <Page @back="back">
     <div class="section">
        <PageIntro :head="$t('views.VerificationAanmelding.pageHeader')" :intro="$t('views.VerificationAanmelding.pageIntro', { contacttype: this.$t(this.contacttypestring) })"/>
        <div class="section-block">
            <p v-if="Number(this.contactmethodnr) === 1">{{ this.email }}</p>
            <p v-if="Number(this.contactmethodnr) === 2">{{ this.phonenumber }}</p>
            <label>{{ this.$t('views.VerificationAanmelding.enterverificationCode') }}</label>
            <input @keypress="isNumber($event)" type="text" pattern="\d*" maxlength="6" v-model="verificationCode" id="input--verificationCode"  />
            <label v-if="Number(contactmethodnr) === 1">{{ this.$t('views.VerificationAanmelding.advice') }}</label>
            <ResendVerificationCode @resendVerificationCode="resendVerificationCode"/>
            <div class="submit">
                <button class="buttonAanmelding" @click="ValidateCode">{{ $t('next') }}</button>
            </div>
        </div>
    </div>

    </Page>
</template>

<style lang="scss">
@import "@/styles/variables/index";
@import "@/styles/input";
@import "@/styles/typography";
@import "@/styles/aanmelding";
.ProvideTestCode {

    .UserConsent {
        margin-bottom: $length-s;
    }

    .OnemomentText {
        display: block;
        margin: 20px;
        padding-block: 30px;
        font-weight: bold;
    }
}
</style>
